import React, {useState, useEffect} from 'react'
import {client} from '../utils/api-client'
import {Button} from '@thryvlabs/maverick'
import {KCPPaymentDetails} from '../components/subscription-summary'
import {AccountDetails} from '../components/account-details'
import {formatSubDetails} from '../utils/util'
import {useNavigate, useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useAsync} from '../utils/use-async'
import rawCountryStates from 'iso3166-2-db/i18n/en'
import validator from 'validator'
import {PhoneNumberUtil} from 'google-libphonenumber'
import * as yup from 'yup'
import {yupResolver} from '@hookform/resolvers/yup'
import {useForm} from 'react-hook-form'
import {BlueGradientBackground} from '../components/AuthForm'
// import keapLogo from '../assets/keap_brand_logo.svg'
import logo from '../assets/thryv-header-logo.svg'
import '../styles/formScreensStyles.css'
import {useSelector} from 'react-redux'

export function ThryvAndKeapHeader() {
  return (
    <header className="header-container">
      <img src={logo} alt="Thryv Logo" className="header-logo" />
      {/* <h1 className="header-divider">|</h1>
      <img src={keapLogo} alt="Keap Logo" className="header-logo" /> */}
    </header>
  )
}

export function OrderDetailsComponent() {
  const [emailRegistered, setEmailRegistered] = useState(true)
  const [listOfStates, setListOfStates] = useState([])
  const [validatedEmail, setValidatedEmail] = useState('')
  const [accountInformation, setAccountInformation] = useState({})
  const [cartDetailObj, setCartDetailObj] = useState({})
  const [subscriptionList, setSubscriptionList] = useState({})
  const [couponList, setCouponList] = useState([])
  const [partnerLinkData, setPartnerLinkData] = useState({})
  const [isFormFilled, setFormFilledStatus] = useState(true)
  const [isLoadingCompleted, setLoadCompletionStatus] = useState(true)
  const [selectedCountry, setSelectedCountry] = useState('US')
  const [currency, setCurrency] = useState('USD')
  const navigate = useNavigate()
  const navData = useLocation()
  const {run} = useAsync({
    status: 'pending',
  })
  console.log({subscriptionList, isLoadingCompleted})
  const phoneUtil = PhoneNumberUtil.getInstance()
  const REQUIRED_FIELD_MESSAGE = 'This field is required'
  const REQUIRED_OPTION_MESSAGE = 'Please select an option'
  const MIN_CHARACTERS_REQUIRED = 'Must be at least 3 characters'
  const MAX_CHARACTERS_REQUIRED = 'Must be at most 120 characters'
  const VALID_EMAIL_MESSAGE = 'Must be a valid email'
  const VALID_WEBSITE_URL_MESSAGE = 'Please enter a valid url'

  // const getStateLabel = countryCode => {
  //   if (['US', 'AU', 'NZ'].includes(countryCode)) {
  //     return 'State'
  //   } else if (countryCode === 'KY') {
  //     return 'City'
  //   } else if (countryCode === 'CA') {
  //     return 'Province'
  //   } else if (countryCode === 'BB') {
  //     return 'Parish'
  //   }
  //   return 'State'
  // }

  const getCurrencyForCountry = countryCode => {
    if (countryCode === 'CA') {
      return 'CAD'
    }
    if (countryCode === 'AU') {
      return 'AUD'
    }
    if (countryCode === 'NZ') {
      return 'NZD'
    }
    return 'USD'
  }

  const validatePostalCode = (value, countryCode) => {
    if (!value) {
      return false
    }
    if (countryCode === 'BB') {
      return /^[A-Za-z]{2}\d{5}$/.test(value)
    }
    if (countryCode === 'KY') {
      return /^[A-Za-z]{2}\d-?\d{4}$/.test(value)
    }
    if (countryCode === 'CA') {
      return /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/.test(value)
    }
    return validator.isPostalCode(value, countryCode)
  }

  const SCHEMA = yup.object().shape({
    firstName: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    lastName: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    email: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .email(VALID_EMAIL_MESSAGE),
    company: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    postCode: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test(
        'validate-postCode-format',
        'Incorrect post code format',
        function (value) {
          return validatePostalCode(value, selectedCountry)
        },
      ),
    websiteName: yup
      .string()
      // .url(VALID_WEBSITE_URL_MESSAGE)
      .matches(
        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        VALID_WEBSITE_URL_MESSAGE,
      )
      .required(REQUIRED_FIELD_MESSAGE),
    address: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    city: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    state: yup.object().shape({
      name: yup.string().required(REQUIRED_OPTION_MESSAGE),
      value: yup.string().required(REQUIRED_OPTION_MESSAGE),
    }),
    mobile: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test(
        'validate-phone-format',
        'Incorrect phone number format',
        function (value) {
          try {
            if (!value) {
              return false
            }
            value = value.replace(/[^\d]/g, '')
            if (selectedCountry === 'US' && value.length > 10) {
              return false
            }
            const parsedPhone = phoneUtil.parse(value, selectedCountry)
            return phoneUtil.isValidNumber(parsedPhone)
          } catch {
            return false
          }
        },
      ),
    companyPhone: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test(
        'validate-phone-format',
        'Incorrect phone number format',
        function (value) {
          try {
            if (!value) {
              return false
            }
            value = value.replace(/[^\d]/g, '')
            if (selectedCountry === 'US' && value.length > 10) {
              return false
            }
            const parsedPhone = phoneUtil.parse(value, selectedCountry)
            return phoneUtil.isValidNumber(parsedPhone)
          } catch {
            return false
          }
        },
      ),
  })

  const DEFAULT_VALUES = {
    email: '',
    prospectEmail: '',
    prospectFirstName: '',
    prospectLastName: '',
  }
  console.log(accountInformation)
  const {
    register,
    formState: {errors},
    control,
    handleSubmit,
    watch,
    trigger,
    //setValue,
  } = useForm({
    defaultValues: DEFAULT_VALUES,
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(SCHEMA),
  })

  const [email, state] = watch(['email', 'state'])

  React.useEffect(() => {
    const states = rawCountryStates[selectedCountry].regions
      .map(({iso, name}) => ({
        name,
        value: iso || name,
      }))
      .sort((a, b) => (a.name > b.name ? 1 : -1))
    setListOfStates(states)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry])

  useEffect(() => {
    console.log({navData, id: navData.state?.id})
    if (!navData || !navData?.state || !navData.state?.id) {
      toast.error('Please contact admin for support')
    }
    const getOrderDetail = async () => {
      try {
        const id = navData?.state?.id || 25
        setLoadCompletionStatus(false)
        let data = await client(`cc/order/keapClient/fetchOrder?id=${id}`)
        let subList = await client(`plans/5/v1/list`)
        setSubscriptionList(subList)
        setPartnerLinkData(data)

        // Set country and currency from keap_partner_links
        const countryCode = data?.country_code || 'US'
        setSelectedCountry(countryCode)
        setCurrency(getCurrencyForCountry(countryCode))

        let oneTimeFees = []
        if (data?.add_on_code?.oneTimeFees) {
          oneTimeFees = data?.add_on_code?.oneTimeFees
        }
        const subJSON = {
          plan: [...data.plan_code.plan],
          addons: [...data.add_on_code.addon],
          oneTimeFees,
        }
        let cartObj = formatSubDetails(
          subJSON,
          subList,
          getCurrencyForCountry(countryCode),
        )
        getCouponDetails(data, cartObj?.plans, countryCode)
        setCartDetailObj(cartObj)
        setLoadCompletionStatus(true)
      } catch (err) {
        console.log('errror', err)
      }
    }

    getOrderDetail()
  }, [])

  const getCouponDetails = async (data, planList = [], country = 'US') => {
    try {
      console.log({data, planList, country})
      const codes = []
      if (data?.plan_code && data?.plan_code.plan.length > 0) {
        for (const plan of data.plan_code.plan) {
          if (!plan.code.startsWith('cc')) {
            codes.push(plan.code)
          }
        }
      }
      let incentiveCodes =
        data?.default_incentive?.defaultIncentives.toString() || ''
      incentiveCodes = incentiveCodes.split(',')

      let couponDetails

      let couponArray = []
      if (incentiveCodes.length > 0) {
        for (let incentiveCode of incentiveCodes) {
          if (incentiveCode.length > 0) {
            let incentiveDetail = await run(
              client(
                `orders/coupon/validate?couponCode=${incentiveCode}&country=${country}&planCode=${codes.join()}`,
              ),
            )
            // incentiveDetails.push(incentiveDetail)
            if (incentiveDetail && incentiveDetail?.isValid) {
              couponArray.push(incentiveDetail)
            }
          }
        }
      }
      if (
        data?.coupon_code?.couponCodes &&
        data.coupon_code.couponCodes.length > 0
      ) {
        for (const coupon of data.coupon_code.couponCodes) {
          couponDetails = await run(
            client(
              `orders/coupon/validate?couponCode=${coupon}&country=${country}&planCode=${codes.join()}`,
            ),
          )
          if (couponDetails && couponDetails?.isValid) {
            couponArray.push(couponDetails)
          }
        }
      }

      // if (incentiveDetails && incentiveDetails?.isValid) {
      //   couponArray.push(incentiveDetails)
      // }
      setCouponList(couponArray)
    } catch (err) {
      console.log(err)
    }
  }

  const handleOrderDetailContinue = async formData => {
    try {
      const accountInformation = setData(formData)
      const id = navData?.state?.id || 25
      let data = {
        linkId: id,
        currentScreen: 'accountInfo',
        baseUrl: window.location.href,
      }
      await run(
        client('keappartner/updatePartnerActivity', {data, method: 'PUT'}),
      )
      setLoadCompletionStatus(false)

      // Check if influencer_name exists in the already-fetched partner link data
      const influencerName = partnerLinkData?.influencer_name
      const hasInfluencer =
        influencerName !== null &&
        influencerName !== undefined &&
        influencerName !== ''

      setLoadCompletionStatus(true)
      localStorage.setItem(
        'orderDetail',
        JSON.stringify({orderDetail: cartDetailObj}),
      )

      if (hasInfluencer) {
        navigate('/client-appointment', {
          state: {
            orderDetail: cartDetailObj,
            accountInformation,
            linkId: id,
            couponList: couponList,
            keapPartnerLinkDetail: partnerLinkData,
            linkType: navData?.state?.linkType,
          },
        })
      } else {
        // Skip appointment and go directly to payment
        navigate('/client-payment', {
          state: {
            orderDetail: cartDetailObj,
            accountInformation,
            linkId: id,
            couponList: couponList,
            keapPartnerLinkDetail: partnerLinkData,
            linkType: navData?.state?.linkType,
            id: id,
            custEmail: accountInformation.email,
          },
        })
      }
    } catch (err) {
      console.log(err)
      setLoadCompletionStatus(true)
    }
  }

  const setData = formData => {
    console.log('formData in setData is ' + JSON.stringify(formData))
    let data = {
      ...formData,
      country: selectedCountry,
      state: formData.state.value,
      businessAddress: {
        city: formData.city,
        state: formData.state.value,
        country: selectedCountry,
        phone: formData.companyPhone,
        street: formData.address,
        postalCode: formData.postCode,
      },
      contactPhone: formData.mobile,
      currency: currency,
      flow: 'new',
      mcDomain: formData.websiteName,
    }
    return data
  }

  const {isMobileViewEnable} = useSelector(state => state.screenView)

  return (
    <>
      <BlueGradientBackground showLogo={false} backgroundHexColor="#F4F6FB" />
      <ThryvAndKeapHeader />
      {isMobileViewEnable ? (
        <>
          <section
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '80%',
              margin: '0% 10%',
              gap: '24px',
            }}
          >
            <section
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <p
                style={{
                  paddingTop: '20px',
                  fontWeight: 700,
                  fontStyle: 'bold',
                  fontFamily: 'Open Sans',
                  fontSize: '20px',
                  color: 'white',
                }}
              >
                Account Information
              </p>
              <div
                style={{
                  backgroundColor: 'white',
                  border: '1px solid #ECEEF1',
                  borderRadius: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  boxShadow: '0px 2px 4px 0px #00000040',
                  paddingInline: '43px',
                  paddingTop: '63px',
                  paddingBottom: '45px',
                  width: '100%',
                }}
              >
                <AccountDetails
                  register={register}
                  errors={errors}
                  listOfStates={listOfStates}
                  validatedEmail={validatedEmail}
                  setValidatedEmail={setValidatedEmail}
                  email={email}
                  emailRegistered={emailRegistered}
                  setEmailRegistered={setEmailRegistered}
                  setAccountInformation={setAccountInformation}
                  setFormFilledStatus={setFormFilledStatus}
                  trigger={trigger}
                  control={control}
                  state={state}
                  handleSubmit={handleSubmit}
                />
              </div>
            </section>
            <section
              style={{
                background: 'white',
                paddingBlock: '20px',
                paddingInline: '20px',
                borderRadius: '10px',
              }}
            >
              <p
                style={{
                  paddingTop: '20px',
                  fontWeight: 700,
                  fontStyle: 'bold',
                  fontFamily: 'Open Sans',
                  fontSize: '20px',
                  marginBottom: '32px',
                  color: 'black',
                }}
              >
                Payment Details
              </p>
              <section
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '24px',
                }}
              >
                <KCPPaymentDetails
                  cartDetailObj={cartDetailObj}
                  paymentDetailType="monthly"
                  currentScreen={'accountInfo'}
                />
                <KCPPaymentDetails
                  paymentDetailType="today"
                  cartDetailObj={cartDetailObj}
                  currentScreen={'accountInfo'}
                  couponList={couponList}
                />
              </section>

              <div className="d-flex justify-content-center my-4">
                <Button
                  style={{
                    width: '100%',
                    paddingBlock: '12px',
                    maxWidth: '350px',
                    fontFamily: 'Open Sans',
                    fontWeight: '700',
                    fontStyle: 'Bold',
                    fontSize: '16px',
                    leadingTrim: 'NONE',
                    lineHeight: '14px',
                    letterSpacing: '0.5%',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                    marginTop: isMobileViewEnable ? '0px' : '52px',
                  }}
                  disabled={!isFormFilled}
                  variant="primary"
                  type="submit"
                  className="new-order-button d-flex justify-content-around align-items-center"
                  onClick={handleSubmit(handleOrderDetailContinue)}
                  name="continue"
                  data-testid={'continue-button'}
                >
                  Continue
                </Button>
              </div>
            </section>
          </section>
        </>
      ) : (
        <>
          <section
            style={{
              display: 'grid',
              gridTemplateColumns: '43fr 29fr',
              width: '100%',
            }}
          >
            <section
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '122px',
                paddingRight: '98px',
              }}
            >
              <h2
                style={{
                  paddingBlock: '40px',
                  fontWeight: 700,
                  fontStyle: 'bold',
                  fontFamily: 'Open Sans',
                  size: '32px',
                  lineHeight: '100%',
                  color: 'white',
                }}
              >
                Account Information
              </h2>
              <div
                style={{
                  backgroundColor: 'white',
                  border: '1px solid #ECEEF1',
                  borderRadius: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  boxShadow: '0px 2px 4px 0px #00000040',
                  paddingInline: '43px',
                  paddingTop: '63px',
                  paddingBottom: '45px',
                  width: '100%',
                }}
              >
                <AccountDetails
                  register={register}
                  errors={errors}
                  listOfStates={listOfStates}
                  validatedEmail={validatedEmail}
                  setValidatedEmail={setValidatedEmail}
                  email={email}
                  emailRegistered={emailRegistered}
                  setEmailRegistered={setEmailRegistered}
                  setAccountInformation={setAccountInformation}
                  setFormFilledStatus={setFormFilledStatus}
                  trigger={trigger}
                  control={control}
                  state={state}
                  handleSubmit={handleSubmit}
                />
                <div className="d-flex justify-content-center my-4">
                  <Button
                    style={{
                      width: '100%',
                      paddingBlock: '12px',
                      maxWidth: '350px',
                      fontFamily: 'Open Sans',
                      fontWeight: '700',
                      fontStyle: 'Bold',
                      fontSize: '16px',
                      leadingTrim: 'NONE',
                      lineHeight: '14px',
                      letterSpacing: '0.5%',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                      marginTop: '52px',
                    }}
                    disabled={!isFormFilled}
                    variant="primary"
                    type="submit"
                    className="new-order-button d-flex justify-content-around align-items-center"
                    onClick={handleSubmit(handleOrderDetailContinue)}
                    name="continue"
                    data-testid={'continue-button'}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </section>
            <section
              style={{
                background: 'white',
                minHeight: '100vh',
                paddingBlock: '90px',
                paddingInline: '77px',
              }}
            >
              <h2
                style={{
                  fontFamily: 'Open Sans',
                  fontWeight: 600,
                  fontStyle: 'SemiBold',
                  fontSize: '32px',
                  lineHeight: '44px',
                  letterSpacing: 0,
                  marginBottom: '40px',
                }}
              >
                Payment Details
              </h2>
              <section
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '52px',
                }}
              >
                <KCPPaymentDetails
                  cartDetailObj={cartDetailObj}
                  paymentDetailType="monthly"
                  currentScreen={'accountInfo'}
                />
                <KCPPaymentDetails
                  paymentDetailType="today"
                  cartDetailObj={cartDetailObj}
                  currentScreen={'accountInfo'}
                  couponList={couponList}
                />
              </section>
            </section>
          </section>
        </>
      )}
    </>
  )
}
